<template>
  <div ref="pageBox">
    <SearchBox ref="SearchBox">
      <el-form slot="form" :inline="true" ref="searchData" :model="searchData" label-width="80px" class="unitWidth" size="small">
        <el-form-item :label="$t('Shift.factory')">
          <el-select v-model="fcCode" :placeholder="$t('base.PleaseSelect')" :clearable="isclear" filterable :disabled="ischeck" @change="searchTable">
            <el-option v-for="factory in factoryList" :key="factory.factoryId" :label="factory.fcName" :value="factory.fcCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('User.RoleName')">
          <el-input v-model="searchData.roleName" :placeholder="$t('base.PleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('Role.RoleCode')">
          <el-input v-model="searchData.roleCode" :placeholder="$t('base.PleaseEnter')"></el-input>
        </el-form-item>
      </el-form>
      <template slot="btns">
        <el-button size="small" type="primary" @click="searchTable">{{$t('base.search')}}</el-button>
      </template>
    </SearchBox>
    <LabelContent :title="$t('Role.RoleList')" ref="LabelContent">
      <div slot="btns">
        <span v-for="acc in access" :key="acc">
          <el-button size="small" type="success" style="margin-right:10px" @click=";(ifAdd = true), updatehOpen()" v-if="acc == 'RL0001'">{{$t('base.add')}}
          </el-button>
        </span>
        <el-button size="small" type="success" @click="roleExport">{{$t('base.export')}}</el-button>
      </div>
    </LabelContent>
    <div class="tableBox">
      <el-table stripe ref="multipleTable" :data="tableData" class="center" @selection-change="handleSelectionChange" @sort-change="sortChange">
        <!--                <el-table-column type="selection" width="55" />-->
        <el-table-column prop="fcName" :label="$t('Shift.factory')" />
        <el-table-column prop="roleName" :label="$t('User.RoleName')" />
        <el-table-column prop="roleCode" :label="$t('Role.RoleCode')" />
        <el-table-column prop="roleLevel" :label="$t('User.RoleLevel')" show-overflow-tooltip>
          <template slot-scope="scope">
            <!-- <span v-if="scope.row.roleLevel == 'factory'">{{$t('User.gcLevel')}}</span>
            <span v-if="scope.row.roleLevel == 'shop'">{{$t('User.cjLevel')}}</span>
            <span v-if="scope.row.roleLevel == 'vsm'">{{$t('User.gdLevel')}}</span>
            <span v-if="scope.row.roleLevel == 'line'">{{$t('User.cxLevel')}}</span> -->
            <span v-if="scope.row.roleLevel == 'factory'">工厂级</span>
            <span v-if="scope.row.roleLevel == 'shop'">车间级</span>
            <span v-if="scope.row.roleLevel == 'vsm'">工段级</span>
            <span v-if="scope.row.roleLevel == 'line'">产线级</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('Role.createTime')" show-overflow-tooltip />
        <el-table-column prop="isActive" :label="$t('User.state')" show-overflow-tooltip>
          <template slot-scope="scope">
            <!-- <span>{{ scope.row.isActive == true ? $t('base.Enable') : $t('base.Disable') }}</span> -->
            <span>{{ scope.row.isActive == true ? '启用' : '不启用' }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.operation')" width="130">
          <template slot-scope="scope">
            <div style="display: flex; align-items: center; justify-content: center">
              <span v-for="acc in access" :key="acc">
                <i class="tools el-icon-s-tools" @click="roleAuth(scope.row.roleId)" v-if="acc == 'RL0004'" />
              </span>
              <span v-for="acc in access" :key="acc">
                <i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false), updatehOpen(scope.row)" v-if="acc == 'RL0002'" />
                <i style="font-size: 1.3vw" class="el-icon-s-opportunity" @click="andontype(scope.row.roleId)" v-if="acc == 'RL0002'" />
                <i class="delBtn iconfont u-shanchu" @click="deleteRow(scope.row)" v-if="acc == 'RL0003'" />
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="paginationChange" @current-change="paginationCurrentChange" :current-page="searchData.page" :page-sizes="[10, 20, 50, 100]" :page-size="searchData.pageSize"
                     layout="total, sizes, prev, pager, next, jumper" :total="searchData.pageCount" />
    </div>
    <el-dialog :title="ifAdd ? $t('base.add') : $t('base.update')" width="500px" :visible.sync="updateShow" style="text-align: left">
      <!--<div class="edit-box">
            <div class="left">-->
      <!--<el-scrollbar class="Yscrollbar">-->
      <div style="display: flex; justify-content: center">
        <el-form :model="roleForm" :rules="rules" ref="roleForm" label-width="90px" class="demo-roleForm">
          <el-form-item :label="$t('Shift.factory')" prop="fcCode">
            <el-select v-model="roleForm.fcCode" :placeholder="$t('base.PleaseSelect')" :disabled="ischeck" filterable @change="selectChange">
              <el-option v-for="factory in factoryList" :key="factory.factoryId" :label="factory.fcName" :value="factory.fcCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('User.RoleName')" prop="roleName">
            <el-input v-model="roleForm.roleName" :placeholder="$t('base.PleaseEnter')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Role.RoleCode')" prop="roleCode">
            <el-input v-model="roleForm.roleCode" :disabled="roleCodeShow" :placeholder="$t('base.PleaseEnter')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('User.RoleLevel')" prop="roleLevel">
            <el-select v-model="roleForm.roleLevel" :placeholder="$t('base.PleaseSelect')">
              <!--                                    <el-option label="公司级" value="company"></el-option>-->
              <el-option :label="$t('User.gcLevel')" value="factory"></el-option>
              <el-option :label="$t('User.cjLevel')" value="shop"></el-option>
              <el-option :label="$t('User.gdLevel')" value="vsm"></el-option>
              <el-option :label="$t('User.cxLevel')" value="line"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('User.state')">
            <el-switch v-model="roleForm.isActive" :active-text="$t('User.Yes')" :inactive-text="$t('User.No')"></el-switch>
          </el-form-item>
          <el-form-item :label="$t('Role.createTime')">
            <el-form-item prop="date1">
              <el-input readonly v-model="roleForm.createTime"></el-input>
            </el-form-item>
          </el-form-item>
        </el-form>
      </div>
      <!--</el-scrollbar>-->
      <!--</div>-->
      <!--<div class="right" v-show="!ifAdd">
            <el-scrollbar class="Yscrollbar">
                <el-tree :data="authTree" ref="authTree" show-checkbox :check-strictly="checkStrictly" node-key="authId" :props="defaultProps"> </el-tree>
            </el-scrollbar>
        </div>-->
      <!--</div>-->
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateShow = false">{{$t('base.cancel')}}</el-button>
        <el-button type="primary" @click="updateRole('roleForm')">{{ ifAdd ? $t('base.add') : $t('base.update') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="treeShow" style="overflow: auto">
      <el-tree :data="roleAuthTree" ref="tree" show-checkbox :default-expanded-keys="expanded" :default-checked-keys="checked" node-key="authId" :props="defaultProps"
               style="width: 100%; height: 30vw; overflow: auto">
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="treeShow = false">{{$t('base.cancel')}}</el-button>
        <el-button type="primary" @click="saveRoleAuth">{{$t('base.confirm')}}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('Role.RoleEdit')" :visible.sync="andontypepop" style="overflow: auto">
      <div style="text-align: left">
        <el-tag :key="role.atId" style="margin-left: 10px" v-for="role in andonNotifyRoleList" closable :disable-transitions="false" @close="onAndonNofityRoleDelete(role)">
          {{ role.atName }}
        </el-tag>
        <div style="margin: 10px">
          <el-select v-model="roleSelected" :placeholder="$t('base.PleaseSelect')" clearable filterable @change="getatId">
            <el-option v-for="item in andonTypes" :key="item.atId" :label="item.atName" :value="item.atId"></el-option>
          </el-select>
          <el-button style="margin-left: 2vw" size="small" @click="onRoleSelectSubmit">{{$t('Role.Submit')}}</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="andontypepop = false">{{$t('base.close')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { addRole, delAndonTypeRuleAuth, deleteRole, getAllROle, getAllRoleAuth } from '../../../libs/api'

const qs = require('qs')
export default {
  name: 'Role',
  computed: {
    isActiveFormat: {
      get() {
        return this.roleForm.isActive ? true : false
      },
      set(newValue) {
        this.roleForm.isActive = newValue ? 1 : 0
      }
    }
  },
  data() {
    return {
      treeShow: false,
      andontypepop: false,
      updateShow: false,
      defaultProps: {
        children: 'children',
        label: 'authName'
      },
      roleId: '',
      andonTypes: [],
      roleSelected: '',
      andontypearId: '',
      andonNotifyRoleList: [],
      ruleIdNotifyEdit: 0,
      aTypeSelected: '',
      searchData: {
        roleName: '',
        roleCode: '',
        roleLevel: null,
        startTime: null,
        endTime: null,
        pageSize: 10,
        page: 1,
        pageCount: 0
      },
      tableData: [],
      ifAdd: false,
      authTree: [],
      checkStrictly: false,
      roleCodeShow: false,
      roleForm: {
        fcCode: String,
        createTime: String,
        isActive: Number,
        roleCode: String,
        roleLevel: String,
        roleName: String,
        createUserId: Number,
        updateUserId: Number,
        roleId: Number
      },
      rules: {
        fcCode: [
          {
            type: 'string',
            required: true,
            message: this.$t('base.PleaseSelect'),
            trigger: 'change'
          }
        ],
        roleName: [
          {
            type: 'string',
            required: true,
            message: this.$t('base.PleaseEnter'),
            trigger: 'blur'
          }
        ],
        roleCode: [
          {
            required: true,
            message: this.$t('base.PleaseEnter'),
            trigger: 'blur'
          }
        ],
        roleLevel: [
          {
            required: true,
            message: this.$t('base.PleaseSelect'),
            trigger: 'change'
          }
        ]
      },
      roleAuths: [],
      //数据源
      roleAuthTree: [{
        children: []
      }],
      expanded: [],
      checked: [],
      roleId: 0,
      access: [],
      fcCode: '',
      factoryList: [],
      userInfo: {},
      role: {},
      ischeck: true,
      isclear: false
    }
  },
  mounted() {
    // this.searchAuthTree()
    this.init()
  },
  methods: {
    init() {
      this.access = JSON.parse(sessionStorage.getItem('auths'))
      // this.userInfo = sessionStorage.getItem("userInfo")
      this.userInfo = this.$store.state.userInfo
      var role = this.userInfo.roles
      for (var i = 0; i < role.length; i++) {
        //所有工厂数据
        if (role[i].factoryId == 0) {
          this.ischeck = false
          this.role = role[i]
          this.isclear = true
          break
        } else {
          if (this.userInfo.factoryId == role[i].factoryId) {
            this.role = role[i]
          }
        }
      }
      this.getAllFactory()
    },
    selectChange() {
      this.$forceUpdate()
    },
    getAndonNotifyRule() {
      let queryParams = {
        roleId: this.roleId
      }
      let options = {
        method: 'get',
        url: this.$api.getAndonTypeRuleAuth,
        params: queryParams
      }
      this.$http.request(options).then(response => {
        let andonTypeSelect = JSON.parse(JSON.stringify(this.andonTypes))
        if (response.status == 100) {
          if (response.data) {
            this.andonNotifyRoleList = response.data
            this.andonNotifyRoleList.forEach(adr => {
              for (let i = andonTypeSelect.length - 1; i >= 0; i--) {
                if (andonTypeSelect[i].atId == adr.atId) {
                  andonTypeSelect.splice(i, 1)
                }
              }
            })
            this.andonTypes = andonTypeSelect
          } else {
            this.andonNotifyRoleList = []
          }
        } else {
          this.$message.error(response.message)
        }
      })
    },
    onRoleSelectSubmit() {
      if (this.roleSelected == undefined || this.roleSelected == '') {
        this.$message.error(this.$t('Role.select'))
        return
      }
      let queryParams = {
        roleId: this.roleId,
        atId: this.andontypearId
      }
      console.log(this.roleId)
      let options = {
        method: 'post',
        url: this.$api.addAndonTypeRuleAuth,
        params: queryParams
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          this.roleSelected = ''
          console.log(response)
          this.getAndonTypes()
        } else {
          this.$message.error(response.message)
        }
      })
    },
    getatId(value) {
      this.andontypearId = value
    },
    getAndonTypes() {
      /*this.andonTypes = []
      this.roleList = []*/
      let options = {
        method: 'GET',
        url: this.$api.getAllAndonType
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          this.andonTypes = response.data
          console.log(response.data)
          this.getAndonNotifyRule()
        }
      })
    },
    onAndonNofityRoleDelete(role) {
      this.$confirm(this.$t('msg.TipsText'), this.$t('msg.Tips'), {
        confirmButtonText: this.$t('base.delete'),
        cancelButtonText: this.$t('base.cancel'),
        type: 'warning'
      }).then(() => {
        this.$http
          .request({
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            params: {
              araId: role.araId
            },
            url: this.$api.delAndonTypeRuleAuth
          })
          .then(response => {
            this.getAndonTypes()
          })
      })
    },
    //查询角色权限
    roleAuth(roleId) {
      let options = {
        method: 'GET',
        url: this.$api.getAllRoleAuth,
        params: { roleId: roleId }
      }
      this.roleId = roleId
      this.$http.request(options).then(response => {
        if (response.status === 100) {
          this.roleAuths = response.data
          this.getAuthorityTree()
        }
      })
    },
    getAuthorityTree() {
      var self = this
      let options = {
        method: 'GET',
        url: this.$api.getAllAuth,
        params: {
          roleId: self.roleId
        }
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          var authoritys = response.data
          console.log('获取所有权限树', authoritys)
          self.expanded = []
          self.checked = []
          self.treeShow = true
          const expanded = []
          const checker = []
          self.roleAuthTree = authoritys
          var mapTreeData = function (authoritys) {
            for (var i = 0; i < authoritys.length; i++) {
              authoritys[i].label = authoritys[i].authName
              authoritys[i].children = authoritys[i].child
              expanded.push(authoritys[i].authId)
              if (authoritys[i].children != undefined) {
                for (var n = 0; n < authoritys[i].children.length; n++) {
                  if (self.roleAuths != undefined) {
                    for (var m = 0; m < self.roleAuths.length; m++) {
                      if (authoritys[i].children[n].authId == self.roleAuths[m].authId) {
                        if (authoritys[i].children[n].child == undefined) {
                          checker.push(authoritys[i].children[n].authId)
                        }
                      }
                    }
                    self.checked = checker
                  }
                }
                if (authoritys[i].children.length > 0) {
                  mapTreeData(authoritys[i].children)
                }
              }
            }
            self.expanded = expanded
          }
          mapTreeData(authoritys)
          self.roleAuthTree[0].child = authoritys
        }
      })
    },
    getAllFactory() {
      let options = {
        method: 'get',
        url: this.$api.getAllFactory
      }
      this.$http.request(options).then(response => {
        this.factoryList = []
        var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        var aa = response.data
        if (this.ischeck) {
          for (var i = 0; i < aa.length; i++) {
            for (let j = 0; j < userInfo.roles.length; j++) {
              if (aa[i].factoryId == userInfo.roles[j].factoryId) {
                this.factoryList.push(aa[i])
                this.fcCode = this.userInfo.fcCode
              }
            }
          }
        } else {
          this.factoryList = response.data
        }
        this.searchTable()
      })
    },
    //表格数据查询
    searchTable() {
      var data = {
        pageSize: this.searchData.pageSize,
        pageNum: this.searchData.page
      }
      if (this.searchData.roleName != undefined && this.searchData.roleName != '') {
        data['roleName'] = this.searchData.roleName
      }
      if (this.searchData.roleCode != undefined && this.searchData.roleCode != '') {
        data['roleCode'] = this.searchData.roleCode
      }
      if (this.fcCode != undefined && this.fcCode != '') {
        data['fcCode'] = this.fcCode
      }
      let options = {
        method: 'GET',
        params: data,
        url: this.$api.getAllRole
      }
      this.$http.request(options).then(response => {
        if (response.status === 100) {
          this.tableData = response.data.list
          this.searchData.pageCount = response.data.total
        }
      })
    },
    //权限树查询
    searchAuthTree() {
      let options = {
        method: 'GET',
        headers: { 'content-type': 'application/json' },
        data: this.searchData,
        url: '/api/auth/authTree'
      }
      this.$http.request(options).then(response => {
        if (response.status === 100) {
          this.authTree = response.data
        }
      })
    },
    //安灯类型权限弹框
    andontype(row) {
      this.andontypepop = true,
        this.roleId = row
      this.andonNotifyRoleList = []
      this.getAndonTypes()
    },
    //编辑框打开
    updatehOpen(row) {
      if (this.ifAdd) {
        //新增
        this.roleForm = {
          createTime: this.getDateTime()
        }
        /*this.roleForm = {
            createTime: this.getDateTime(),
            roleLevel: 1,
            roleName: '',
            roleId: null,
            roleCode: null
            createUserId: null,
            updateUserId: null
        }*/
        if (this.ischeck) {
          this.roleForm.fcCode = this.userInfo.fcCode
        }
        this.roleCodeShow = false
        this.updateShow = true
      } else {
        //修改
        this.roleForm = JSON.parse(JSON.stringify(row))
        this.roleCodeShow = true
        this.updateShow = true
        /*let options = {
            method: 'PUT',
            showLoading: true,
            headers: { 'content-type': 'application/json' },
            url: this.$api.editRole,
            params: {
                roleForm: this.roleForm
            }
        }
        this.$http.request(options).then(response => {
            if (response.status === 100) {
                this.updateShow = true
                let auths = []
                let screen = list => {
                    list.filter(l => {
                        auths.push(l.authId)
                        if (typeof l.children != 'undefined' && l.children.length) {
                            screen(l.children)
                        }
                    })
                }
                screen(response.data)

                this.checkStrictly = true
                this.$nextTick(() => {
                    this.$refs.authTree.setCheckedKeys(auths, true)
                    this.checkStrictly = false
                })
            }
        })*/
      }
    },
    updateRole(roleForm) {
      if (this.ifAdd) {
        this.$refs[roleForm].validate((valid) => {
          if (valid) {
            let options = {
              method: 'POST',
              showLoading: true,
              url: this.$api.addRole,
              data: this.roleForm
            }
            this.$http.request(options).then(response => {
              if (response.status == 100) {
                this.$message.success(this.$t('base.SuccessfullyAdded'))
                this.updateShow = false
                this.searchTable()
              } else {
                this.$message.error(response.message)
              }
            })
          } else {
            return false
          }
        })
      } else {
        //修改
        this.$refs[roleForm].validate((valid) => {
          if (valid) {
            let options = {
              method: 'POST',
              showLoading: true,
              url: this.$api.editRole,
              data: this.roleForm
            }
            this.$http.request(options).then(response => {
              if (response.status == 100) {
                this.$message.success(this.$t('base.SuccessfullyUpdated'))
                this.updateShow = false
                this.searchTable()
              } else {
                this.$message.error(response.message)
              }
            })
          } else {
            return false
          }
        })
      }
    },
    async roleExport() {
      let params = {}
      params['language'] = this.$t('lang')
      if (this.searchData.roleName != undefined && this.searchData.roleName != '') {
        params['roleName'] = this.searchData.roleName
      }
      if (this.searchData.roleCode != undefined && this.searchData.roleCode != '') {
        params['roleCode'] = this.searchData.roleCode
      }
      let options = {
        url: this.$api.exportRole,
        method: 'POST',
        params: params,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json;application/ms-excel;application/ms-excel;charset=utf-8'
        }
      }
      let result = await this.$http.request(options)
      var elink = document.createElement('a')
      elink.download = this.$t('Role.RoleInfo')  //设置名称
      elink.style.display = 'none'
      var blob = new Blob([result], { type: 'application/vnd.ms-excel' })
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)  //追加节点
      elink.click()
      document.body.removeChild(elink)  //删除节点
    },
    saveRoleAuth() {
      var self = this
      var authIds = []
      var nodes = this.$refs.tree.getCheckedNodes()
      var nodeFus = this.$refs.tree.getHalfCheckedKeys()
      console.log('nodes', nodes)
      console.log('nodeFus', nodeFus)
      if (nodes.length > 0) {
        for (let i = 0; i < nodes.length; i++) {
          if (nodes[i].parentId != undefined && nodes[i].parentId != 0) {
            authIds.push(nodes[i].authId)
          }
        }
      }
      if (nodeFus.length > 0) {
        for (let j = 0; j < nodeFus.length; j++) {
          authIds.push(nodeFus[j])
        }
      }
      var params = {
        roleId: self.roleId,
        roleAuths: authIds
      }
      console.log('params', params)
      let options = {
        method: 'POST',
        url: this.$api.editUserRole,
        data: params
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          this.$message.success(this.$t('base.SuccessfullyUpdated'))
          this.treeShow = false
        }
      })
    },
    //编辑框确认
    updateComf() {
      if (!this.submitForm('roleForm')) return
      let roleUrl = '/api/role/add'
      var requestTimer = this.ifAdd ? 1 : 0
      var requested = () => {
        requestTimer++
        if (requestTimer > 1) {
          this.updateShow = false
          this.searchTable()
        }
      }
      if (!this.ifAdd) {
        //修改
        roleUrl = '/api/role/update'
        let auths = []
        this.$refs.authTree.getCheckedNodes(false, true).forEach(item => {
          auths.push(item.authId)
        })
        this.$http
          .request({
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            data: {
              roleId: this.roleForm.roleId,
              authIds: auths
            },
            url: '/api/role/bindAuth'
          })
          .then(response => {
            if (response.status != 100) {
              this.$message.error(response.message)
            }
            requested()
          })
          .catch(err => {
            this.$message.error(err)
            requested()
          })
      }
      this.$http
        .request({
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          data: this.roleForm,
          url: roleUrl
        })
        .then(response => {
          if (response.status != 100) {
            this.$message.error(response.message)
          }
          requested()
        })
        .catch(err => {
          this.$message.error(err)
          requested()
        })
    },
    deleteRow(row) {
      this.$confirm(this.$t('msg.TipsText'), this.$t('msg.Tips'), {
        confirmButtonText: this.$t('base.delete'),
        cancelButtonText: this.$t('base.cancel'),
        type: 'warning'
      })
        .then(() => {
          this.$http
            .request({
              method: 'POST',
              headers: { 'content-type': 'application/json' },
              params: { roleId: row.roleId },
              url: this.$api.deleteRole
            })
            .then(response => {
              this.searchTable()
              // this.$message.success(response.message);
            })
            .catch(err => {
              this.searchTable()
              // this.$message.error(err);
            })
        })
        .catch(() => {
          this.searchTable()
          this.$message({
            type: 'info',
            message: this.$t('msg.cancel')
          })
        })
    },
    //分页
    paginationChange(val) {
      this.searchData.pageSize = val
      this.searchTable()
    },
    paginationCurrentChange(val) {
      this.searchData.page = val
      this.searchTable()
    },
    //多选框选择 返回当前已选行数据(Array)
    handleSelectionChange(val) {
      console.log(val)
    },
    //从后台获取数据,重新排序
    sortChange(val) {
      // 详细文档参考： https://element.eleme.cn/2.13/#/zh-CN/component/table
      console.log(val)
    },
    //自定义排序规则 sort-method
    sortByDate(a, b) {
      console.log(a, b)
      if (a < b) return -1
    },
    //表单验证
    submitForm(formName) {
      let result = true
      this.$refs[formName].validate(valid => {
        if (valid) {
          result = true
        } else {
          result = false
        }
      })
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
  .Yscrollbar {
      height: 100%;
  }

  .edit-box {
      width: 100%;
      height: 500px;
      display: flex;

      .left {
          width: 350px;
          height: 100%;
          flex-shrink: 0;
          overflow: hidden;
      }

      .right {
          flex: 1;
          border-left: 5px solid #00000010;
          padding-left: 20px;
          height: 100%;
          flex-basis: 0;
          overflow: hidden;
      }
  }
</style>
